module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28530",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9539",
      "ably-hubspot-js": "static-2.4573",
      "atom": "static-1.4932",
      "conversations-async-data": "static-2.7526",
      "conversations-error-reporting": "static-1.8738",
      "conversations-internal-pub-sub": "static-1.15827",
      "conversations-internal-schema": "static-1.12593",
      "conversations-message-history": "static-1.12214",
      "conversations-test-sdk": "static-1.10360",
      "conversations-visitor-experience-components": "static-1.21893",
      "head-dlb": "static-1.4884",
      "hs-promise-utils": "static-1.5455",
      "hs-test-utils": "static-1.7869",
      "hubspot-dlb": "static-2.1806",
      "HubStyleTokens": "static-2.11305",
      "I18n": "static-7.1592",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2879",
      "jasmine-runner": "static-1.6332",
      "quartz": "static-1.6813",
      "react-dlb": "static-1.74",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.61",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4336",
      "StyleGuideUI": "static-3.485",
      "transmute": "static-2.85",
      "urlinator": "static-1.4393",
      "usage-tracker": "static-1.7197",
      "usage-tracker-core": "static-1.7047",
      "usage-tracker-public": "static-1.7008",
      "viral-links-lib": "static-1.6902",
      "visitor-ui-component-library": "static-1.5994",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4671",
      "conversations-prop-types": "static-1.7314",
      "conversations-visitor-message-history": "static-1.20630",
      "cssUtils": "static-1.757",
      "enviro": "static-4.416",
      "flux-actions": "static-1.320",
      "foundations-components": "static-1.7639",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6079",
      "hubspot-url-utils": "static-1.3957",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9436",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.377",
      "raven": "static-3.5768",
      "react": "static-7.182",
      "react-aria": "static-1.62",
      "react-dom": "static-7.85",
      "react-redux": "static-7.67",
      "react-rhumb": "static-1.16512",
      "react-utils": "static-2.5233",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8007",
      "signup-constants": "static-1.18521",
      "styled-components": "static-2.85",
      "usage-tracker-multi": "static-1.5611",
      "visitor-ui-component-library-icons": "static-1.5805",
      "hs-promise-rejection-tracking": "static-1.5433",
      "raven-hubspot": "static-1.6075",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3288",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.82",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.78",
      "quartz-config": "static-1.591",
      "quartz-core": "static-1.6032",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4703",
      "foundations-theming": "static-1.4273",
      "UIComponents": "static-3.8252",
      "customer-data-email": "static-1.17779",
      "cv-backend-services": "static-1.1524",
      "immutable-less": "static-1.4516",
      "conversations-skeleton-state": "static-1.7110",
      "crm-events-viz-core": "static-1.32673",
      "customer-data-objects": "static-1.7514",
      "icons": "static-2.634",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4504",
      "ui-images": "static-2.1117",
      "HeadJS": "static-2.727",
      "framer-motion": "static-1.68",
      "hs-test-utils-bend-plugin": "static-1.2980",
      "msw": "static-1.39",
      "testing-library": "static-1.148",
      "i18n-data": "static-1.218",
      "moment-timezone": "static-5.79",
      "jasmine": "static-4.4188",
      "signup-ui-url-generator": "static-2.7897",
      "HubStyle": "static-2.11613",
      "quartz-i18n": "static-1.488",
      "sassPrefix": "static-1.153",
      "bend-plugin-foundations-components": "static-1.3908",
      "floating-ui": "static-1.52",
      "foundations-theming-specialty": "static-1.1989",
      "hs-story-utils": "static-1.9288",
      "react-virtualized": "static-2.95",
      "tanstack-table": "static-1.51",
      "trellis-assets": "static-1.1379",
      "ui-fonts": "static-1.567",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3796",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5614",
      "bender-build-tools": "static-1.3014",
      "dispatcher": "static-1.133",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.812",
      "hubspotter-http": "static-1.4536",
      "mobile-manifest-mixins": "static-1.502",
      "module-federation": "static-1.19",
      "quartz-auth": "static-1.488",
      "quartz-head": "static-1.478",
      "quartz-routing": "static-1.243",
      "quartz-test": "static-1.488",
      "quartz-tracking": "static-1.192",
      "usage-tracker-container": "static-1.7187",
      "bend-plugin-foundations-theming": "static-1.2756",
      "foundations-theming-base": "static-1.3258",
      "stylex": "static-1.28",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4513",
      "customer-data-ui-utilities": "static-1.9686",
      "FileManagerCore": "static-1.38602",
      "FileManagerLib": "static-1.38743",
      "hubspot-apollo-client": "static-1.4741",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.522",
      "timezone-utils": "static-2.5106",
      "ui-gdpr-components": "static-1.10210",
      "ts-schema": "static-1.3963",
      "ai-components-ui-library": "static-1.8537",
      "avatar-components": "static-1.2354",
      "content-assistance-lib": "static-1.7535",
      "crm-component-utils": "static-1.38635",
      "crm-display-components": "static-1.24385",
      "crm-fe-perf": "static-1.22766",
      "crm-links": "static-1.6131",
      "crm-message-bus": "static-1.42553",
      "crm-search-service-types": "static-1.1013",
      "crm-source-interpretation-lib": "static-1.5193",
      "customer-data-communicator": "static-1.45093",
      "customer-data-filters-ui": "static-1.39128",
      "customer-data-objects-ui-components": "static-1.12874",
      "customer-data-properties": "static-1.50981",
      "customer-data-rte": "static-1.32598",
      "draft-plugins": "static-2.21418",
      "file-manager-components": "static-1.23103",
      "framework-data-schema-resolvers": "static-1.6735",
      "frontend-preferences-client": "static-1.7786",
      "hubspot-prosemirror": "static-1.17782",
      "object-comments-thread-lib": "static-1.10241",
      "reference-resolvers-lite": "static-1.7947",
      "ui-addon-upgrades": "static-9.17749",
      "universal-associations-select": "static-1.10858",
      "universal-record-utils-lib": "static-1.421",
      "inbound-db-properties-service-client": "static-1.3729",
      "property-translator": "static-1.5272",
      "chirp-fetch": "static-1.1745",
      "hub-http-shared-msw-handlers": "static-1.9628",
      "hubspotter-http-shared-msw-handlers": "static-1.9626",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4883",
      "react-dnd-compat": "static-1.4482",
      "audio-components": "static-1.5699",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.36254",
      "foundations-components-legacy": "static-1.664",
      "immerable": "static-1.4016",
      "ui-universal-auth": "static-1.8784",
      "video-components": "static-1.12773",
      "video-data-lib": "static-1.34428",
      "video-embed": "static-1.35262",
      "hubspot-apollo-cache": "static-1.200",
      "chatspot-core": "static-1.20595",
      "ContentUtils": "static-1.67813",
      "copilot-toolkit": "static-1.10696",
      "superstore": "static-1.4631",
      "ui-addon-video-player": "static-1.8558",
      "ui-coaching-tips": "static-1.28109",
      "card-properties-lib": "static-1.43701",
      "commerce-subscription-lib": "static-1.36637",
      "crm-actions": "static-1.6171",
      "crm-cards-sdk": "static-1.43104",
      "customer-data-properties-shared-msw-handlers": "static-1.8955",
      "customer-data-property-utils": "static-1.7942",
      "customer-data-tracking": "static-1.6744",
      "hs-entities": "static-1.548",
      "inbound-db-meta-service-client": "static-1.3478",
      "pulse": "static-1.385",
      "framework-data-table": "static-2.11568",
      "location-customization-utils-lib": "static-1.8758",
      "calling-error-reporting": "static-1.31168",
      "calling-internal-common": "static-1.31162",
      "calling-usage-tracker": "static-1.6403",
      "crm_data": "static-4.91454",
      "customer-data-content": "static-1.26992",
      "draft-content-plugins": "static-1.27866",
      "draft-convert": "static-2.69",
      "draft-extend": "static-3.71",
      "draft-js": "static-5.74",
      "draft-signature-plugin": "static-1.23668",
      "EmailSignatureEditor": "static-1.24022",
      "hubspot-prosemirror-plugins": "static-1.17774",
      "integration-settings-components": "static-1.14999",
      "integrations-lib": "static-1.15620",
      "integrations-tracking-lib": "static-1.5452",
      "native-integrations-shared-strings": "static-1.7649",
      "nav-meta": "static-1.29109",
      "onboarding-scopes": "static-1.6325",
      "outreach-assistant-email-generation": "static-1.5904",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37491",
      "react-colorpicker": "static-2.10073",
      "reference-resolvers": "static-1.8026",
      "rich-text-lib": "static-1.19580",
      "sales-email-signature-service-client": "static-1.3705",
      "sequences-lib": "static-1.7792",
      "ui-addon-i18n": "static-1.11007",
      "ui-addon-iframeable": "static-1.8909",
      "ui-business-units-lib": "static-1.8894",
      "ui-shepherd-react": "static-3.10008",
      "user-context": "static-1.4962",
      "whatsapp-sending-lib": "static-1.5052",
      "customer-data-filters-ui-msw-helpers": "static-1.21563",
      "customer-data-reference-ui-components": "static-1.13010",
      "FormUrlGenerator": "static-2.4583",
      "framework-builder-read-service-client": "static-1.3891",
      "framework-data-schema-quick-fetch": "static-1.6640",
      "multi-account-reference-resolvers": "static-1.838",
      "onboarding-tours": "static-1.16348",
      "reporting-datasets-permissions-lib": "static-1.13237",
      "SharedI18nStrings": "static-1.181",
      "ui-addon-teams": "static-1.21329",
      "calling-global-api": "static-1.63919",
      "calling-lifecycle-internal": "static-1.65301",
      "calling-lifecycle-messages": "static-1.57595",
      "commerce-products-lib": "static-1.9020",
      "conditional-properties-service-client": "static-1.3681",
      "external-options-client-types": "static-1.4042",
      "google-libphonenumber": "static-1.34",
      "inbounddb-objects-service-types": "static-1.4106",
      "meetings-icalendar-utils-lib": "static-1.494",
      "multi-currency-client-types": "static-1.3573",
      "object-builder-ui-client": "static-1.48201",
      "pipeline-validation-client-types": "static-1.3847",
      "property-value-citations": "static-1.1595",
      "smart-property-lib": "static-1.6173",
      "tiered-pricing": "static-1.926",
      "ui-addon-form-validation": "static-1.10855",
      "video-components-external": "static-1.10770",
      "batch-promise": "static-1.1413",
      "crm-pipelines-api-client-types": "static-1.4023",
      "persist-promise": "static-1.3570",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24903",
      "knowledge-content-types": "static-1.8420",
      "payment-link-components": "static-1.23103",
      "ui-addon-emoji-picker": "static-1.9749",
      "call-summary": "static-1.38610",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9774",
      "laboratory-lib": "static-3.7021",
      "merchandise-lib": "static-1.261",
      "purchase-motions-components": "static-1.5577",
      "crm-object-search-query-utilities": "static-1.9225",
      "amplitude-session-replay-browser": "static-1.56",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.579",
      "content-icons-ui": "static-1.2181",
      "social-insights-client-types": "static-1.21564",
      "outpost": "static-1.4062",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4671",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5456",
      "magpie-types": "static-1.4916",
      "simple-logging-lib": "static-1.2912",
      "growth-onboarding-feedback-components": "static-1.6443",
      "customer-data-sidebar": "static-2.45583",
      "enrichment-properties-lib": "static-1.15291",
      "commerce-billing-lib": "static-1.18662",
      "commerce-shared-components-lib": "static-1.18120",
      "commerce-tools-ui-lib": "static-1.9956",
      "directed-graph": "static-1.801",
      "event-emitter": "static-1.809",
      "fast-json-patch": "static-1.59",
      "customer-data-associations": "static-1.7184",
      "deal-intel-decorators": "static-1.1485",
      "reporting-data": "static-1.66780",
      "tanstack-virtual": "static-1.26",
      "ui-addon-draggable": "static-3.4630",
      "crm-record-cards-service-types": "static-1.3500",
      "self-service-api": "static-1.10104",
      "crm_universal": "static-1.21754",
      "SalesContentIndexUI": "static-3.8999",
      "content-embed-lib": "static-1.7202",
      "data-model-builder-lib": "static-1.11828",
      "remote-ui": "static-1.61",
      "ui-components-test-utils": "static-1.5443",
      "ui-extensions-remote-renderer": "static-1.16537",
      "universal-page-editor-lib": "static-1.2863",
      "integrations-error-boundary-lib": "static-1.13035",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10236",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45533",
      "data-token-picker": "static-1.16152",
      "sequences-client-types-lib": "static-1.7649",
      "foundations-components-test-utils": "static-1.5122",
      "navigation-messaging": "static-1.6799",
      "getting-started-shared-tasks": "static-1.18055",
      "getting-started-shared-tasks-store": "static-1.17173",
      "onboarding-tours-utils": "static-1.414",
      "messaging-usage-based-billing-components-lib": "static-1.658",
      "whatsapp-management-lib": "static-1.8211",
      "growth-data-modal": "static-1.5221",
      "growth-onboarding-confetti": "static-1.2934",
      "growth-onboarding-next-action-utils": "static-1.1461",
      "navigation-components": "static-1.17472",
      "onboarding-tours-client": "static-1.4562",
      "ui-shepherd-tracker": "static-1.7389",
      "shared-worker-versioning": "static-1.10901",
      "voice-sms-access-library": "static-1.428",
      "commerce-permissions": "static-1.625",
      "products-iframe-lib": "static-1.7503",
      "products-ui-components-shared-msw-handlers": "static-1.10010",
      "breeze-intelligence-kit": "static-1.5409",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9711",
      "fsm": "static-1.3592",
      "policy-lib": "static-1.6640",
      "react-tinymce": "static-1.54797",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53923",
      "tinymce-plugins": "static-1.57037",
      "tinymce-themes": "static-1.55893",
      "content-media-composition-data-lib": "static-1.11702",
      "content-media-compositions": "static-2.15709",
      "idb-keyval": "static-1.40",
      "media-bridge-lib": "static-1.18674",
      "ui-addon-opt": "static-4.8245",
      "commerce-tours-lib": "static-1.5816",
      "growth-onboarding-reliability": "static-1.4948",
      "sales-checkout-service-client": "static-1.3530",
      "ai-addon-copilot-preview": "static-1.7749",
      "calling-cross-tab-library": "static-1.19133",
      "calling-lifecycle-usage-tracker": "static-1.8296",
      "wootric-nps": "static-1.6844",
      "growth-monetization-service-types": "static-1.4361",
      "nav-client-types": "static-1.2219",
      "purchase-motions-api": "static-1.5580",
      "trials-service-types": "static-1.3762",
      "reactive-lib": "static-1.587",
      "card-payment-highlight-lib": "static-1.36690",
      "card-subscription-highlight-lib": "static-1.39060",
      "commerce-contract-lib": "static-1.11427",
      "invoices-highlight-card-lib": "static-1.54227",
      "orders-highlight-card-lib": "static-1.21031",
      "products-highlight-card-lib": "static-1.17304",
      "project-storage": "static-1.4595",
      "quotes-highlight-card-lib": "static-1.71401",
      "usage-based-billing-components-lib": "static-1.8182",
      "utility-belt": "static-1.2402",
      "payments-enrollment-embed-lib": "static-1.22185",
      "growth-onboarding-empty-states": "static-1.5455",
      "InboxConnectUtils": "static-4.14386",
      "payments-post-enroll-local-storage-lib": "static-1.4976",
      "qrcode-generator": "static-1.65",
      "deal-intel-utils": "static-1.1489",
      "storybook-react": "static-1.29",
      "reporting-client-types": "static-1.2406",
      "react-flip-move": "static-1.66",
      "FireAlarmUi": "static-1.4391",
      "sales-templates-service-types-lib": "static-1.4050",
      "ui-asset-management-lib": "static-1.10797",
      "association-settings-lib": "static-1.9844",
      "collaboration-sidebar": "static-1.57299",
      "conditional-property-settings-modal": "static-1.12095",
      "data-model-commons-lib": "static-1.12129",
      "feedback-loader": "static-1.28993",
      "nudge-client-utils": "static-1.2278",
      "final-form": "static-1.66",
      "html-to-image": "static-1.50",
      "object-definition-builder-lib": "static-1.6933",
      "property-management-iframe": "static-1.12610",
      "property-usages-lib": "static-1.5270",
      "reactflow": "static-1.60",
      "simple-data-table": "static-1.2352",
      "used-in-list-lib": "static-1.6788",
      "visual-association": "static-1.5717",
      "highcharts": "static-8.100",
      "reporting-visualizations": "static-1.58856",
      "ui-extensibility-client-types": "static-1.3803",
      "automation-platform-service-types": "static-1.2543",
      "ContentData": "static-1.67888",
      "email-portal-health-service-types": "static-1.838",
      "marketing-email-service-types": "static-1.1811",
      "messaging-shared-utils-lib": "static-1.107",
      "messaging-user-info-utils-lib": "static-1.277",
      "content-whatsapp-service-types": "static-1.297",
      "marketing-platform-lib": "static-1.6706",
      "short-messages-app-service-client": "static-1.3867",
      "ui-tool-access": "static-1.10007",
      "growth-onboarding-next-action-components": "static-1.1489",
      "user-context-client": "static-1.4477",
      "calling-orchestration-schema": "static-1.35205",
      "sales-views-client-types": "static-1.4135",
      "trellis-story-utils": "static-1.4382",
      "hub-http-contrib": "static-1.2905",
      "interframe": "static-3.4624",
      "tinymce-data": "static-1.40008",
      "ui-addon-sales-email": "static-1.5075",
      "codemirror": "static-5.91",
      "layout-dnd-components": "static-1.12161",
      "layout-dnd-utils": "static-1.11136",
      "react-codemirror": "static-1.10488",
      "ui-brand-identity-lib": "static-1.14331",
      "NamespacedHubStyle": "static-2.8953",
      "hls.js": "static-1.35",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9503",
      "ai-settings-ui-library": "static-1.7644",
      "copilot-plugins": "static-1.10669",
      "eligibility-engine-service-types": "static-1.3043",
      "products-ui-components": "static-1.39539",
      "quotes-ui-lib": "static-1.80122",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6828",
      "invoices-ui-lib": "static-1.54243",
      "commerce-products-api": "static-1.2051",
      "SafeStorage": "static-1.4264",
      "invoices-iframe-lib": "static-1.56301",
      "quotes-modal-lib": "static-1.102079",
      "platform-infra-nav-components": "static-1.7550",
      "reporting-ui-components": "static-2.64051",
      "subscription-experience-data-types": "static-1.14665",
      "marketplace-ui-apps-core": "static-1.17660",
      "stripe-embedded-components": "static-1.7248",
      "ui-addon-react-router-dom": "static-1.9407",
      "association-translator": "static-1.3049",
      "crm-settings-header-lib": "static-1.8183",
      "settings-ui-nav": "static-2.10047",
      "chatspot-widget-iframe": "static-1.20587",
      "collaboration-sidebar-common": "static-1.2096",
      "crm-properties-common-lib": "static-1.5735",
      "ui-addon-draggable-compat": "static-2.4116",
      "nudge-custom-function-registry": "static-1.2035",
      "nudge-renderer-utils": "static-1.2354",
      "whisper-core-api": "static-1.6157",
      "property-management-common": "static-1.4897",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14905",
      "advanced-menus-lib": "static-1.11873",
      "ExportDialog": "static-6.10250",
      "ui-memberships-settings-lib": "static-1.33616",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9461",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13773",
      "highlight.js": "static-1.75",
      "reporting-action-components": "static-1.40819",
      "reporting-snowflake": "static-1.55398",
      "commerce-tax-lib": "static-1.380",
      "property-description-translator": "static-1.3718",
      "commerce-analytics-service-client": "static-1.3518",
      "totals-ui-components": "static-1.23155",
      "reporting-plugins": "static-1.10056",
      "reporting-reports": "static-1.66458",
      "edison-service-client-types": "static-1.254",
      "developer-experience-shared-components": "static-1.10363",
      "marketplace-ui-client-types": "static-1.16534",
      "marketplace-ui-common": "static-1.19127",
      "ui-addon-integrations-directory-panel": "static-2.7853",
      "stripe-connect-js": "static-1.65",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14904",
      "simple-menus-lib": "static-1.16421",
      "academy-common-lib": "static-1.13233",
      "dashboard-lib": "static-1.80881",
      "share-with-third-party-component-lib": "static-1.8555",
      "commerce-totals-service-types": "static-1.3699",
      "campaign-roi-lib": "static-1.8466",
      "apps-service-types": "static-1.3739",
      "oauth-service-types": "static-1.4109",
      "react-window": "static-1.13",
      "academy-service-client": "static-1.3542",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28530",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9539",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4573",
      "atom": "/atom/static-1.4932",
      "conversations-async-data": "/conversations-async-data/static-2.7526",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8738",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15827",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12593",
      "conversations-message-history": "/conversations-message-history/static-1.12214",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10360",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21893",
      "head-dlb": "/head-dlb/static-1.4884",
      "hs-promise-utils": "/hs-promise-utils/static-1.5455",
      "hs-test-utils": "/hs-test-utils/static-1.7869",
      "hubspot-dlb": "/hubspot-dlb/static-2.1806",
      "HubStyleTokens": "/HubStyleTokens/static-2.11305",
      "I18n": "/I18n/static-7.1592",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2879",
      "jasmine-runner": "/jasmine-runner/static-1.6332",
      "quartz": "/quartz/static-1.6813",
      "react-dlb": "/react-dlb/static-1.74",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.61",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4336",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4393",
      "usage-tracker": "/usage-tracker/static-1.7197",
      "usage-tracker-core": "/usage-tracker-core/static-1.7047",
      "usage-tracker-public": "/usage-tracker-public/static-1.7008",
      "viral-links-lib": "/viral-links-lib/static-1.6902",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5994",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4671",
      "conversations-prop-types": "/conversations-prop-types/static-1.7314",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20630",
      "cssUtils": "/cssUtils/static-1.757",
      "enviro": "/enviro/static-4.416",
      "flux-actions": "/flux-actions/static-1.320",
      "foundations-components": "/foundations-components/static-1.7639",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6079",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9436",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.377",
      "raven": "/raven/static-3.5768",
      "react": "/react/static-7.182",
      "react-aria": "/react-aria/static-1.62",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.67",
      "react-rhumb": "/react-rhumb/static-1.16512",
      "react-utils": "/react-utils/static-2.5233",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8007",
      "signup-constants": "/signup-constants/static-1.18521",
      "styled-components": "/styled-components/static-2.85",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5611",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5805",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
      "raven-hubspot": "/raven-hubspot/static-1.6075",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3288",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.78",
      "quartz-config": "/quartz-config/static-1.591",
      "quartz-core": "/quartz-core/static-1.6032",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4703",
      "foundations-theming": "/foundations-theming/static-1.4273",
      "UIComponents": "/UIComponents/static-3.8252",
      "customer-data-email": "/customer-data-email/static-1.17779",
      "cv-backend-services": "/cv-backend-services/static-1.1524",
      "immutable-less": "/immutable-less/static-1.4516",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7110",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32673",
      "customer-data-objects": "/customer-data-objects/static-1.7514",
      "icons": "/icons/static-2.634",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4504",
      "ui-images": "/ui-images/static-2.1117",
      "HeadJS": "/HeadJS/static-2.727",
      "framer-motion": "/framer-motion/static-1.68",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2980",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.148",
      "i18n-data": "/i18n-data/static-1.218",
      "moment-timezone": "/moment-timezone/static-5.79",
      "jasmine": "/jasmine/static-4.4188",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7897",
      "HubStyle": "/HubStyle/static-2.11613",
      "quartz-i18n": "/quartz-i18n/static-1.488",
      "sassPrefix": "/sassPrefix/static-1.153",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3908",
      "floating-ui": "/floating-ui/static-1.52",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1989",
      "hs-story-utils": "/hs-story-utils/static-1.9288",
      "react-virtualized": "/react-virtualized/static-2.95",
      "tanstack-table": "/tanstack-table/static-1.51",
      "trellis-assets": "/trellis-assets/static-1.1379",
      "ui-fonts": "/ui-fonts/static-1.567",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3796",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5614",
      "bender-build-tools": "/bender-build-tools/static-1.3014",
      "dispatcher": "/dispatcher/static-1.133",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.812",
      "hubspotter-http": "/hubspotter-http/static-1.4536",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.502",
      "module-federation": "/module-federation/static-1.19",
      "quartz-auth": "/quartz-auth/static-1.488",
      "quartz-head": "/quartz-head/static-1.478",
      "quartz-routing": "/quartz-routing/static-1.243",
      "quartz-test": "/quartz-test/static-1.488",
      "quartz-tracking": "/quartz-tracking/static-1.192",
      "usage-tracker-container": "/usage-tracker-container/static-1.7187",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2756",
      "foundations-theming-base": "/foundations-theming-base/static-1.3258",
      "stylex": "/stylex/static-1.28",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4513",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9686",
      "FileManagerCore": "/FileManagerCore/static-1.38602",
      "FileManagerLib": "/FileManagerLib/static-1.38743",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4741",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.522",
      "timezone-utils": "/timezone-utils/static-2.5106",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10210",
      "ts-schema": "/ts-schema/static-1.3963",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8537",
      "avatar-components": "/avatar-components/static-1.2354",
      "content-assistance-lib": "/content-assistance-lib/static-1.7535",
      "crm-component-utils": "/crm-component-utils/static-1.38635",
      "crm-display-components": "/crm-display-components/static-1.24385",
      "crm-fe-perf": "/crm-fe-perf/static-1.22766",
      "crm-links": "/crm-links/static-1.6131",
      "crm-message-bus": "/crm-message-bus/static-1.42553",
      "crm-search-service-types": "/crm-search-service-types/static-1.1013",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5193",
      "customer-data-communicator": "/customer-data-communicator/static-1.45093",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39128",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12874",
      "customer-data-properties": "/customer-data-properties/static-1.50981",
      "customer-data-rte": "/customer-data-rte/static-1.32598",
      "draft-plugins": "/draft-plugins/static-2.21418",
      "file-manager-components": "/file-manager-components/static-1.23103",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6735",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7786",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17782",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10241",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7947",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17749",
      "universal-associations-select": "/universal-associations-select/static-1.10858",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.421",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3729",
      "property-translator": "/property-translator/static-1.5272",
      "chirp-fetch": "/chirp-fetch/static-1.1745",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9628",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9626",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4883",
      "react-dnd-compat": "/react-dnd-compat/static-1.4482",
      "audio-components": "/audio-components/static-1.5699",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.36254",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.664",
      "immerable": "/immerable/static-1.4016",
      "ui-universal-auth": "/ui-universal-auth/static-1.8784",
      "video-components": "/video-components/static-1.12773",
      "video-data-lib": "/video-data-lib/static-1.34428",
      "video-embed": "/video-embed/static-1.35262",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.200",
      "chatspot-core": "/chatspot-core/static-1.20595",
      "ContentUtils": "/ContentUtils/static-1.67813",
      "copilot-toolkit": "/copilot-toolkit/static-1.10696",
      "superstore": "/superstore/static-1.4631",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8558",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28109",
      "card-properties-lib": "/card-properties-lib/static-1.43701",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36637",
      "crm-actions": "/crm-actions/static-1.6171",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43104",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8955",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7942",
      "customer-data-tracking": "/customer-data-tracking/static-1.6744",
      "hs-entities": "/hs-entities/static-1.548",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3478",
      "pulse": "/pulse/static-1.385",
      "framework-data-table": "/framework-data-table/static-2.11568",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8758",
      "calling-error-reporting": "/calling-error-reporting/static-1.31168",
      "calling-internal-common": "/calling-internal-common/static-1.31162",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6403",
      "crm_data": "/crm_data/static-4.91454",
      "customer-data-content": "/customer-data-content/static-1.26992",
      "draft-content-plugins": "/draft-content-plugins/static-1.27866",
      "draft-convert": "/draft-convert/static-2.69",
      "draft-extend": "/draft-extend/static-3.71",
      "draft-js": "/draft-js/static-5.74",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23668",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24022",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17774",
      "integration-settings-components": "/integration-settings-components/static-1.14999",
      "integrations-lib": "/integrations-lib/static-1.15620",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5452",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7649",
      "nav-meta": "/nav-meta/static-1.29109",
      "onboarding-scopes": "/onboarding-scopes/static-1.6325",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5904",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37491",
      "react-colorpicker": "/react-colorpicker/static-2.10073",
      "reference-resolvers": "/reference-resolvers/static-1.8026",
      "rich-text-lib": "/rich-text-lib/static-1.19580",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3705",
      "sequences-lib": "/sequences-lib/static-1.7792",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11007",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8909",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8894",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10008",
      "user-context": "/user-context/static-1.4962",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5052",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21563",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13010",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4583",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3891",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6640",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.838",
      "onboarding-tours": "/onboarding-tours/static-1.16348",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13237",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
      "ui-addon-teams": "/ui-addon-teams/static-1.21329",
      "calling-global-api": "/calling-global-api/static-1.63919",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65301",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57595",
      "commerce-products-lib": "/commerce-products-lib/static-1.9020",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3681",
      "external-options-client-types": "/external-options-client-types/static-1.4042",
      "google-libphonenumber": "/google-libphonenumber/static-1.34",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4106",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.494",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3573",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48201",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3847",
      "property-value-citations": "/property-value-citations/static-1.1595",
      "smart-property-lib": "/smart-property-lib/static-1.6173",
      "tiered-pricing": "/tiered-pricing/static-1.926",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10855",
      "video-components-external": "/video-components-external/static-1.10770",
      "batch-promise": "/batch-promise/static-1.1413",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4023",
      "persist-promise": "/persist-promise/static-1.3570",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24903",
      "knowledge-content-types": "/knowledge-content-types/static-1.8420",
      "payment-link-components": "/payment-link-components/static-1.23103",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9749",
      "call-summary": "/call-summary/static-1.38610",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9774",
      "laboratory-lib": "/laboratory-lib/static-3.7021",
      "merchandise-lib": "/merchandise-lib/static-1.261",
      "purchase-motions-components": "/purchase-motions-components/static-1.5577",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9225",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.579",
      "content-icons-ui": "/content-icons-ui/static-1.2181",
      "social-insights-client-types": "/social-insights-client-types/static-1.21564",
      "outpost": "/outpost/static-1.4062",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4671",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5456",
      "magpie-types": "/magpie-types/static-1.4916",
      "simple-logging-lib": "/simple-logging-lib/static-1.2912",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6443",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45583",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15291",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18662",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18120",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9956",
      "directed-graph": "/directed-graph/static-1.801",
      "event-emitter": "/event-emitter/static-1.809",
      "fast-json-patch": "/fast-json-patch/static-1.59",
      "customer-data-associations": "/customer-data-associations/static-1.7184",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1485",
      "reporting-data": "/reporting-data/static-1.66780",
      "tanstack-virtual": "/tanstack-virtual/static-1.26",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4630",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3500",
      "self-service-api": "/self-service-api/static-1.10104",
      "crm_universal": "/crm_universal/static-1.21754",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8999",
      "content-embed-lib": "/content-embed-lib/static-1.7202",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11828",
      "remote-ui": "/remote-ui/static-1.61",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5443",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16537",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2863",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13035",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10236",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45533",
      "data-token-picker": "/data-token-picker/static-1.16152",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7649",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5122",
      "navigation-messaging": "/navigation-messaging/static-1.6799",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18055",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17173",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.414",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.658",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8211",
      "growth-data-modal": "/growth-data-modal/static-1.5221",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2934",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1461",
      "navigation-components": "/navigation-components/static-1.17472",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4562",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7389",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10901",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.428",
      "commerce-permissions": "/commerce-permissions/static-1.625",
      "products-iframe-lib": "/products-iframe-lib/static-1.7503",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10010",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5409",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9711",
      "fsm": "/fsm/static-1.3592",
      "policy-lib": "/policy-lib/static-1.6640",
      "react-tinymce": "/react-tinymce/static-1.54797",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53923",
      "tinymce-plugins": "/tinymce-plugins/static-1.57037",
      "tinymce-themes": "/tinymce-themes/static-1.55893",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11702",
      "content-media-compositions": "/content-media-compositions/static-2.15709",
      "idb-keyval": "/idb-keyval/static-1.40",
      "media-bridge-lib": "/media-bridge-lib/static-1.18674",
      "ui-addon-opt": "/ui-addon-opt/static-4.8245",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5816",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4948",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3530",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7749",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19133",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8296",
      "wootric-nps": "/wootric-nps/static-1.6844",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4361",
      "nav-client-types": "/nav-client-types/static-1.2219",
      "purchase-motions-api": "/purchase-motions-api/static-1.5580",
      "trials-service-types": "/trials-service-types/static-1.3762",
      "reactive-lib": "/reactive-lib/static-1.587",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36690",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39060",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11427",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54227",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21031",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17304",
      "project-storage": "/project-storage/static-1.4595",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71401",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8182",
      "utility-belt": "/utility-belt/static-1.2402",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22185",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5455",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14386",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4976",
      "qrcode-generator": "/qrcode-generator/static-1.65",
      "deal-intel-utils": "/deal-intel-utils/static-1.1489",
      "storybook-react": "/storybook-react/static-1.29",
      "reporting-client-types": "/reporting-client-types/static-1.2406",
      "react-flip-move": "/react-flip-move/static-1.66",
      "FireAlarmUi": "/FireAlarmUi/static-1.4391",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4050",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10797",
      "association-settings-lib": "/association-settings-lib/static-1.9844",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57299",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12095",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12129",
      "feedback-loader": "/feedback-loader/static-1.28993",
      "nudge-client-utils": "/nudge-client-utils/static-1.2278",
      "final-form": "/final-form/static-1.66",
      "html-to-image": "/html-to-image/static-1.50",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6933",
      "property-management-iframe": "/property-management-iframe/static-1.12610",
      "property-usages-lib": "/property-usages-lib/static-1.5270",
      "reactflow": "/reactflow/static-1.60",
      "simple-data-table": "/simple-data-table/static-1.2352",
      "used-in-list-lib": "/used-in-list-lib/static-1.6788",
      "visual-association": "/visual-association/static-1.5717",
      "highcharts": "/highcharts/static-8.100",
      "reporting-visualizations": "/reporting-visualizations/static-1.58856",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3803",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2543",
      "ContentData": "/ContentData/static-1.67888",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.838",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1811",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.107",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.277",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.297",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6706",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
      "ui-tool-access": "/ui-tool-access/static-1.10007",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1489",
      "user-context-client": "/user-context-client/static-1.4477",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35205",
      "sales-views-client-types": "/sales-views-client-types/static-1.4135",
      "trellis-story-utils": "/trellis-story-utils/static-1.4382",
      "hub-http-contrib": "/hub-http-contrib/static-1.2905",
      "interframe": "/interframe/static-3.4624",
      "tinymce-data": "/tinymce-data/static-1.40008",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5075",
      "codemirror": "/codemirror/static-5.91",
      "layout-dnd-components": "/layout-dnd-components/static-1.12161",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11136",
      "react-codemirror": "/react-codemirror/static-1.10488",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14331",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8953",
      "hls.js": "/hls.js/static-1.35",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9503",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7644",
      "copilot-plugins": "/copilot-plugins/static-1.10669",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3043",
      "products-ui-components": "/products-ui-components/static-1.39539",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80122",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6828",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54243",
      "commerce-products-api": "/commerce-products-api/static-1.2051",
      "SafeStorage": "/SafeStorage/static-1.4264",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56301",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102079",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7550",
      "reporting-ui-components": "/reporting-ui-components/static-2.64051",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14665",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17660",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7248",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9407",
      "association-translator": "/association-translator/static-1.3049",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8183",
      "settings-ui-nav": "/settings-ui-nav/static-2.10047",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20587",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2096",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5735",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4116",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2035",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2354",
      "whisper-core-api": "/whisper-core-api/static-1.6157",
      "property-management-common": "/property-management-common/static-1.4897",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14905",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11873",
      "ExportDialog": "/ExportDialog/static-6.10250",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33616",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9461",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13773",
      "highlight.js": "/highlight.js/static-1.75",
      "reporting-action-components": "/reporting-action-components/static-1.40819",
      "reporting-snowflake": "/reporting-snowflake/static-1.55398",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.380",
      "property-description-translator": "/property-description-translator/static-1.3718",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3518",
      "totals-ui-components": "/totals-ui-components/static-1.23155",
      "reporting-plugins": "/reporting-plugins/static-1.10056",
      "reporting-reports": "/reporting-reports/static-1.66458",
      "edison-service-client-types": "/edison-service-client-types/static-1.254",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10363",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16534",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19127",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7853",
      "stripe-connect-js": "/stripe-connect-js/static-1.65",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14904",
      "simple-menus-lib": "/simple-menus-lib/static-1.16421",
      "academy-common-lib": "/academy-common-lib/static-1.13233",
      "dashboard-lib": "/dashboard-lib/static-1.80881",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8555",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3699",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8466",
      "apps-service-types": "/apps-service-types/static-1.3739",
      "oauth-service-types": "/oauth-service-types/static-1.4109",
      "react-window": "/react-window/static-1.13",
      "academy-service-client": "/academy-service-client/static-1.3542",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28530",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};